import React from 'react'

import { Label, LabelSize } from '@octane/spark'

interface CountBadgeProps {
    count: number
}

// Accent badge showing the number of selected dropdown options.
// Default uses Spark sapphire Label; Buffalo variant overrides to brand yellow.
export default function CountBadge({ count }: CountBadgeProps) {
    return <Label text={`${count}`} color="sapphire" size={LabelSize.SMALL} />
}
